import React from 'react';
import appGoogleTracking from '../../../modules/googletracking';

/*
    Google tagging plan added on links using : appGoogleTracking.processEventCTA
*/

const footerlinksV1 = () => (
    <div className="footer__legal_v1">
        <div className='group__legal__link'>
            <span className="legal__link">
                <a className="js-event-cta"
                    href="https://www.milka.at/bedingungen-zur-nutzung"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Nutzungsbedingungen"
                    data-event="footer_contact_menu"
                    data-category="Footer"
                    data-action="Select Menu"
                    data-label="Nutzungsbedingungen"
                    onClick={appGoogleTracking.processEventCTA}>Nutzungsbedingungen</a>
            </span>
            <span className="legal__link">
                <a className="js-event-cta"
                    href="https://privacy.mondelezinternational.com/eu/de-DE/privacy-notice/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Datenschutzhinweis"
                    data-event="footer_contact_menu"
                    data-category="Footer"
                    data-action="Select Menu"
                    data-label="Datenschutzhinweis"
                    onClick={appGoogleTracking.processEventCTA}>Datenschutzhinweis
                </a>
            </span>
            <span className="legal__link">
                <a className="js-event-cta"
                    href="https://milka.at/allgemeine-geschaftsbedingungen-new"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Geschäftsbedingungen"
                    data-event="footer_contact_menu"
                    data-category="Footer"
                    data-action="Select Menu"
                    data-label="Geschäftsbedingungen"
                    onClick={appGoogleTracking.processEventCTA}>Geschäftsbedingungen</a>
            </span>
            <span className="legal__link">
                <a className="js-event-cta"
                    href="https://milka.at/impressum"
                    title="Impressum"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-event="footer_contact_menu"
                    data-category="Footer"
                    data-action="Select Menu"
                    data-label="Impressum"
                    //  data-label="NEUES" 
                    onClick={appGoogleTracking.processEventCTA}>Impressum</a>
            </span>
            <span className="legal__link">
                <a className="js-event-cta"
                    href="https://www.milka.at/nutzungsbasierte-online-werbung"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Nutzungsbasierte Online-Werbung"
                    data-event="footer_contact_menu"
                    data-category="Footer"
                    data-action="Select Menu"
                    data-label="Nutzungsbasierte Online-Werbung"
                    onClick={appGoogleTracking.processEventCTA}>Nutzungsbasierte Online-Werbung</a>
            </span>
        </div>
        <div className='group__legal__link2'>
            <span className="legal__link">
                <a className="js-event-cta"
                    target="_blank"
                    href="/cookies"
                    title="Cookie-Hinweis"
                    data-event="footer_contact_menu"
                    data-category="Footer"
                    data-action="Select Menu"
                    data-label="Cookie-Hinweis"
                    onClick={appGoogleTracking.processEventCTA}>Cookie-Hinweis</a>
            </span>
            <span className="legal__link">
                <a className="js-event-cta"
                    href="https://contactus.mdlzapps.com/milka/contact/de-DE/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Kontakt"
                    data-event="footer_contact_menu"
                    data-category="Footer"
                    data-action="Select Menu"
                    data-label="Kontakt"
                    onClick={appGoogleTracking.processEventCTA}>Kontakt</a>
            </span>
            {/* <span className="legal__link">
                <a className="js-event-cta" 
                    href="/faq"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="FAQ"
                    data-event="footer_contact_menu"
                    data-category="Footer"
                    data-action="Select Menu"
                    data-label="FAQ"
                    onClick={appGoogleTracking.processEventCTA}>FAQ</a>
            </span> */}
        </div>
    </div>
);

export default footerlinksV1;